import React from "react";
import { useAuth } from "../Auth/Auth";

export default function Header() {
    const { logout } = useAuth();

    return (
        <header className="navbar navbar-dark sticky-top bg-cherry-red flex-md-nowrap p-0 shadow">
            <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3" href="#">
                Uyirmozhy Admin
            </a>

            <div className="navbar-nav">
                <div className="nav-item text-nowrap">
                    <span
                        className="nav-link px-3"
                        style={{ cursor: "pointer" }}
                        onClick={logout}
                    >
                        Sign out
                    </span>
                </div>
            </div>
        </header>
    );
}